import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeInvoices'
})
export class FilterPipeInvoices implements PipeTransform {
    transform(invoices: any, term?: any): any {
        if (term === undefined) return invoices;
        if (term === null) return invoices;

        if (invoices != null) {
            return invoices.filter(function (invoice) {
                if (invoice.customer != undefined)
                    if (invoice.customer.toLowerCase().includes(term.toLowerCase()))
                        return invoice;
                if (invoice.invoice_number != undefined)
                    if (invoice.invoice_number.toString().toLowerCase().includes(term.toLowerCase()))
                        return invoice;

            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/invoices/filter.pipe.ts